module.exports = __webpack_public_path__ + "static/media/picpicker-saas.b5bc253f.png";